import { Box } from "@mui/material";
import EmptyIconStatus from "components/EmptyState/EmptyIconStatus";
import ReactECharts from "echarts-for-react";
import { analysisColors } from "features/configure/chartColors";
import { Loading } from "features/common";
import { useIntl } from "react-intl";

export default function BarChart({ title, isShowObjective, data, isLoading }) {
  const { formatMessage } = useIntl();
  const colors = analysisColors.small;

  const series = [
    {
      name: formatMessage({ id: "global.commonWord.users" }),
      type: "bar",
      data: data.map((d) => d.totalUser),
      label: {
        show: true,
        fontSize: 10,
        formatter: (params) => (params.value === 0 ? "" : params.value),
      },
    },
    {
      name: formatMessage({ id: "global.commonWord.wallets" }),

      type: "bar",
      data: data.map((d) => d.walletsConnected),
      label: {
        show: true,
        fontSize: 10,
        formatter: (params) => (params.value === 0 ? "" : params.value),
      },
    },
  ];

  if (isShowObjective) {
    series.push({
      name: formatMessage({ id: "global.commonWord.objectiveAchieved" }),

      type: "bar",
      data: data.map((d) => d.objectiveAchieved),
      label: {
        show: true,
        fontSize: 10,
        formatter: (params) => (params.value === 0 ? "" : params.value),
      },
    });
  }

  const option = {
    tooltip: {},
    legend: {
      data: series.map((s) => s.name),
      left: 0,
      bottom: 0,
    },
    xAxis: {
      type: "category",
      data: data.map((d) => d.browser),
    },
    yAxis: {
      type: "value",
    },
    series: series.map((s, idx) => ({
      ...s,
      itemStyle: { color: colors[idx] },
    })),
  };

  return (
    <Box
      sx={{
        p: 3,
        height: "395px",
        bgcolor: "#fff",
        borderRadius: "4px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          fontSize: "16px",
          fontWeight: 500,
          color: (theme) => theme.customColors.grey[700],
        }}
      >
        {title}
      </Box>
      {isLoading ? (
        <Box sx={{ position: "relative", height: "100%" }}>
          <Loading open={true} fullScreen={false} isChart={true} />
        </Box>
      ) : data.length > 0 ? (
        <ReactECharts option={option} style={{ flex: 1, width: "100%" }} />
      ) : (
        <EmptyIconStatus
          icon="chart"
          emptyTitle={formatMessage({ id: "emptyState.barChart.title" })}
          emptyDescription={formatMessage({
            id: "emptyState.barChart.description",
          })}
        />
      )}
    </Box>
  );
}
